import CheckedIcon from './component'

export default CheckedIcon
